import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_2 = { class: "flex items-center gap-x-2" }

import { computed, ref } from 'vue';
import { ClipboardCheck, Droplet, Plus, Printer } from 'lucide-vue-next';
import ActionModal from '@/components/common/actionModal/ActionModal.vue';
import { Button } from '@/components/ui/button';
import { useInventoryFormModal, type InventoryFormPrefill } from '@/composables/inventory/useInventoryFormModal';
import { useInventoryScope } from '@/composables/inventory/useInventoryScope';
import { MedicineInventoryFormId } from '@/types';
import BulkCountDialog from './BulkCountDialog.vue';
import BulkPurchaseDialog from './BulkPurchaseDialog.vue';
import CountSheetDialog from './CountSheetDialog.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'InventoryActions',
  props: {
    prefill: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props;

const { initialState, stepConfig, header, loadingKey, openCreate } = useInventoryFormModal();

const isBulkCountOpen = ref(false);
const isBulkPurchaseOpen = ref(false);
const isCountSheetOpen = ref(false);

/** A detail page counts and buys its own key through the single forms; the list and the log count and buy for a whole farm at once. */
const countsOneKey = computed(() => props.prefill.drugId !== undefined);

/** Buying, spilling and counting write stock, so they need ReadWrite on the farm - or on any farm, where the form lets the reader pick one. */
const { writableFarms } = useInventoryScope();
const canWrite = computed(() => writableFarms.value.some((farm) => props.prefill.farmId === undefined || farm.farm_id === props.prefill.farmId));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!countsOneKey.value)
      ? (_openBlock(), _createBlock(_unref(Button), {
          key: 0,
          variant: "outline",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isCountSheetOpen.value = true))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Printer), {
              class: "size-4",
              "aria-hidden": "true"
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('views.health.inventory.buttons.print')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (canWrite.value)
      ? (_openBlock(), _createBlock(ActionModal, {
          key: 1,
          "initial-step-index": 1,
          "initial-state": _unref(initialState),
          "step-config": _unref(stepConfig),
          header: _unref(header)
        }, {
          default: _withCtx(({ open }) => [
            _createElementVNode("div", _hoisted_2, [
              (countsOneKey.value)
                ? (_openBlock(), _createBlock(_unref(Button), {
                    key: 0,
                    variant: "outline",
                    disabled: _unref(loadingKey) !== null,
                    onClick: ($event: any) => (_unref(openCreate)(_unref(MedicineInventoryFormId).Count, _ctx.prefill, open))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ClipboardCheck), {
                        class: "size-4",
                        "aria-hidden": "true"
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('views.health.inventory.buttons.count')), 1)
                    ]),
                    _: 2
                  }, 1032, ["disabled", "onClick"]))
                : (_openBlock(), _createBlock(_unref(Button), {
                    key: 1,
                    variant: "outline",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (isBulkCountOpen.value = true))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ClipboardCheck), {
                        class: "size-4",
                        "aria-hidden": "true"
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('views.health.inventory.buttons.count')), 1)
                    ]),
                    _: 1
                  })),
              _createVNode(_unref(Button), {
                variant: "outline",
                disabled: _unref(loadingKey) !== null,
                onClick: ($event: any) => (_unref(openCreate)(_unref(MedicineInventoryFormId).Waste, _ctx.prefill, open))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Droplet), {
                    class: "size-4",
                    "aria-hidden": "true"
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('views.health.inventory.buttons.waste')), 1)
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"]),
              (countsOneKey.value)
                ? (_openBlock(), _createBlock(_unref(Button), {
                    key: 2,
                    disabled: _unref(loadingKey) !== null,
                    onClick: ($event: any) => (_unref(openCreate)(_unref(MedicineInventoryFormId).Purchase, _ctx.prefill, open))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Plus), {
                        class: "size-4",
                        "aria-hidden": "true"
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('views.health.inventory.buttons.newPurchase')), 1)
                    ]),
                    _: 2
                  }, 1032, ["disabled", "onClick"]))
                : (_openBlock(), _createBlock(_unref(Button), {
                    key: 3,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (isBulkPurchaseOpen.value = true))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Plus), {
                        class: "size-4",
                        "aria-hidden": "true"
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('views.health.inventory.buttons.newPurchase')), 1)
                    ]),
                    _: 1
                  }))
            ])
          ]),
          _: 1
        }, 8, ["initial-state", "step-config", "header"]))
      : _createCommentVNode("", true),
    (canWrite.value && !countsOneKey.value)
      ? (_openBlock(), _createBlock(BulkCountDialog, {
          key: 2,
          open: isBulkCountOpen.value,
          "onUpdate:open": _cache[3] || (_cache[3] = ($event: any) => ((isBulkCountOpen).value = $event))
        }, null, 8, ["open"]))
      : _createCommentVNode("", true),
    (canWrite.value && !countsOneKey.value)
      ? (_openBlock(), _createBlock(BulkPurchaseDialog, {
          key: 3,
          open: isBulkPurchaseOpen.value,
          "onUpdate:open": _cache[4] || (_cache[4] = ($event: any) => ((isBulkPurchaseOpen).value = $event))
        }, null, 8, ["open"]))
      : _createCommentVNode("", true),
    (!countsOneKey.value)
      ? (_openBlock(), _createBlock(CountSheetDialog, {
          key: 4,
          open: isCountSheetOpen.value,
          "onUpdate:open": _cache[5] || (_cache[5] = ($event: any) => ((isCountSheetOpen).value = $event))
        }, null, 8, ["open"]))
      : _createCommentVNode("", true)
  ]))
}
}

})